import { useState } from "react";
import heart from "../../assets/heart.svg";
import { useEffect } from "react";
import req from "../../axios/interceptedAxiosInstance";
import { successToast } from "../../notification/notification";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNairaSign } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { addToFav, removeFromFav } from "../../slice/favourite/favouriteSlice";
import { addItemToCart, removeItemFromCart } from "../../slice/cart/cartSlice";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";

const Products = ({ favourite, data, favouriteFunc, cartFunc, cart }) => {
  const { user } = useAuth();

  const [disable, setDisable] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { product_image, product_name, product_prices, id, seller } = data;
  const { front_view } = product_image;
  const { full_name } = seller;

  // checks if a produc is marked as favourite
  const [isFavourite, setIsFavourite] = useState(
    favourite.some((fav) => fav.product.product_name === product_name)
  );

  // checks if a product is present in user cart. this controls the state of the product button in explore (add/remove from cart)
  const [isInCart, setIsinCart] = useState(
    cart.some((cart) => cart.product.product_name === product_name)
  );

  const addToFavourite = async () => {
    if (user.data) {
      setDisable(true);
      try {
        const response = await req.post("favourite/store", {
          product_id: Number(id),
        });
        dispatch(
          addToFav({
            id: response.data.status.id,
            created_at: response.data.status.created_at,
            updated_at: response.data.status.updated_at,
            product: response.data.status.product,
          })
        );
        successToast(`${response.data.message}: item added to favourite`);
        setDisable(false);
      } catch (error) {
        console.log(error);
        setDisable(false);
      }
    } else {
      navigate("/sign-in");
    }
  };

  const removeFromFavourite = async () => {
    if (user.data) {
      setDisable(true);
      try {
        const id = await favourite.filter(
          (fav) => fav.product.product_name === product_name
        );
        const response = await req.delete(`favourite/${id[0].id}`);
        dispatch(removeFromFav(id[0].id));
        successToast(`${response.data.message}: item removed from favourite`);
        setDisable(false);
      } catch (error) {
        console(error);
        setDisable(false);
      }
    } else {
      navigate("/sign-in");
    }
  };

  const addToCart = async () => {
    if (user.data) {
      setDisable(true);
      try {
        const response = await req.post("cart/store", {
          product_id: Number(id),
        });
        dispatch(
          addItemToCart({
            id: response.data.status.id,
            created_at: response.data.status.created_at,
            updated_at: response.data.status.updated_at,
            product: response.data.status.product,
            status: response.data.status.status,
          })
        );
        successToast(`${response.data.message}: item added to cart`);
        setDisable(false);
      } catch (error) {
        console.log(error);
        setDisable(false);
      }
    } else {
      navigate("/sign-in");
    }
  };

  const removeFromCart = async () => {
    if (user.data) {
      setDisable(true);
      try {
        const identifier = await cart.filter(
          (cart) => cart.product.product_name === product_name
        );
        const response = await req.delete(`cart/${identifier[0].id}`);
        dispatch(removeItemFromCart(identifier[0].id));
        successToast(`${response.data.message}: item removed from cart`);
        setDisable(false);
      } catch (error) {
        console.log(error);
        setDisable(false);
      }
    } else {
      navigate("/sign-in");
    }
  };

  useEffect(() => {
    setIsFavourite(
      favourite.some((fav) => fav.product.product_name === product_name)
    );
  }, [favourite, product_name]);

  useEffect(() => {
    setIsinCart(
      cart.some((cart) => cart.product.product_name === product_name)
    );
  }, [cart, product_name]);

  return (
    <div className="w-[47%] md:w-[31.5%] lg:w-[160.5px] xl:w-[17%] mt-5">
      <img
        src={front_view}
        alt="product front view"
        className="h-[120px] md:h-200 xl:h-[170px] w-full"
      />

      <div className="">
        <div className="flex justify-between items-center pt-3 border-b pb-3">
          <p className="font-normal text-sm">
            {product_name.substring(0, 9)}...
          </p>

          {isFavourite ? (
            <button
              className={`w-6 h-6 rounded-full flex justify-center items-center border border-label`}
              onClick={removeFromFavourite}
              disabled={disable}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                fill="currentColor"
                className="bi bi-heart-fill text-red-500"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
                />
              </svg>
            </button>
          ) : (
            <button
              className={`w-6 h-6 rounded-full flex justify-center items-center border border-label`}
              onClick={addToFavourite}
              disabled={disable}
            >
              <img src={heart} alt="heart" className="w-3 h-3" />
            </button>
          )}
        </div>

        <div className="border-b pb-3">
          {product_prices.map(({ price }) => (
            <div
              className="flex items-center pt-3"
              key={`${price}${Math.random()}`}
            >
              <FontAwesomeIcon
                icon={faNairaSign}
                className="font-bold text-lg lg:text-xl"
              />
              <p
                key={`${price}${Math.random()}`}
                className="font-bold text-lg lg:text-xl "
              >{`${price.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.00`}</p>
            </div>
          ))}
        </div>

        <p className="font-normal text-xs pt-3">
          Sold by <span className="text-logoRed">{full_name}</span>
        </p>

        <div className="mt-5">
          {isInCart ? (
            <button
              className="w-full font-bold text-xs text-white h-10 md:11 border rounded-3xl border-logoRed outline-none bg-logoRed"
              onClick={removeFromCart}
              disabled={disable}
            >
              Remove from cart
            </button>
          ) : (
            <button
              className="w-full font-bold text-xs text-logoRed h-10 md:11 border rounded-3xl border-logoRed outline-none bg-white"
              onClick={addToCart}
              disabled={disable}
            >
              Add to Cart
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Products;
